import { IWebhookService, WebhookFormat } from '@truckdown/systems';
import context from '@truckdown/components-systems';
import { showMessage } from "../../Utilities/Utilities";
import { defineComponent, ref, Ref } from "vue";
import { required, helpers } from '@vuelidate/validators';
import { useVuelidate, Validation } from '@vuelidate/core';

interface IData {
    isLoading: Ref<boolean>,
    url: Ref<string>,
    format: Ref<'Json' | 'Microsoft Teams' | 'Slack'>,
    validation: Ref<Validation<any>>
}

const getData = function () {
    let data = {
        isLoading: ref<boolean>(false),
        format: ref<'Json' | 'Microsoft Teams' | 'Slack'>('Json'),
        url: ref<string>('')
    } as IData;

    data.validation = useVuelidate(getValidationRules(data), data);

    return data;
}

const url = helpers.regex(/^(https:)(\/\/([a-z0-9\-._~%!$&'()*+,;=]+@)?([a-z0-9\-._~%]+|\[[a-f0-9:.]+\])(:443)?)((\/[a-zA-Z0-9\-._~%!$&'()*+,;=:@]+)*\/?)(\?[a-zA-Z0-9\-._~%!$&'()*+,;=:@\/?]*)?(\#[a-zA-Z0-9\-._~%!$&'()*+,;=:@\/?]*)?$/)

const getValidationRules = function (data: IData) {
    return {
        "url": {
            required: helpers.withMessage('Please enter a valid https url', required),
            url: helpers.withMessage('Invalid web address format', url)
        }
    };
};

const getFormat = function (format: string) {
    if (format == 'Microsoft Teams') {
        return WebhookFormat.Teams;
    } else if (format == 'Slack') {
        return WebhookFormat.Slack;
    } else {
        return WebhookFormat.Json;
    }
}

const getMethods = function (data: IData, ctx: any) {
    return {
        cancelClick: function () {
            ctx.emit('cancel');
        },
        saveClick: async function () {
            if (!data.isLoading.value) {
                try {
                    data.isLoading.value = true;

                    let isValid = await data.validation.value.$validate();
                    if (isValid) {
                        let service = await context.getService<IWebhookService>('IWebhookService');
                        let res = await service.register({
                            accountId: context.user?.accountId ?? '',
                            address: data.url.value,
                            isVerified: false,
                            format: getFormat(data.format.value)
                        });
                        if (res.ok) {
                            ctx.emit('added', res.data);
                        } else {
                            showMessage('An error occured while trying to add  a webhook address.', "danger", true, true);
                        }
                    }
                }
                catch (err) {
                    console.log(err);
                    showMessage('An error occured while trying to add  a webhook address.', "danger", true, true);
                }
                finally {
                    data.isLoading.value = false;
                }
            }
        }
    };
}

export default defineComponent({
    props: {
    },
    components: {
    },
    emits: ['cancel', 'added'],
    setup: function (props, ctx) {
        let data = getData();
        let methods = getMethods(data, ctx);

        return {
            ...data,
            ...methods
        };
    }
});